import {ImageModel} from "../../models";
import {TransformBase} from "../TranformBase";

export class ImagesTransform extends TransformBase {
  public makeImageModel(dto: string | null): ImageModel {
    return {
      url: dto,
    };
  }
}

export const imagesTransform = new ImagesTransform();
